import { render, staticRenderFns } from "./cms-block-card.vue?vue&type=template&id=2b4472a3&scoped=true"
import script from "./cms-block-card.vue?vue&type=script&lang=js"
export * from "./cms-block-card.vue?vue&type=script&lang=js"
import style0 from "./cms-block-card.vue?vue&type=style&index=0&id=2b4472a3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4472a3",
  null
  
)

export default component.exports